import get from 'lodash/get';
import isArray from 'lodash/isArray';
import every from 'lodash/every';
import defaults from 'lodash/defaults';
import extend from 'lodash/extend';
import uuid from 'uuid/v4';
import * as StructureContainers from '@Services/StructureContainers';

// Note: most of this will likely be removed once the new QB is fully migrated to React

let groupCount = 0;
const SHELL_PROPS = ['id', 'type', 'isShell', 'items', 'operator', 'operatorQualifier', 'isImmutable', 'groupName', 'displayName'];

function removeAdditionalInfo(info) {
  const { result } = info.split('').reduce(
    ({ result: acc, depth }, ch) => {
      if (ch === '(') return { result: acc, depth: depth + 1 };
      if (ch === ')') return { result: acc, depth: depth > 0 ? depth - 1 : 0 };
      if (depth === 0) return { result: acc + ch, depth };
      return { result: acc, depth };
    },
    { result: '', depth: 0 }
  );
  return result.trim();
}

function removeShell(index, parent) {
  const array = isArray(parent) ? parent : parent.items;
  const currentProp = array[index];
  // angular-specific: $$hashKey is injected by AngularJS — strip it when page is migrated
  const subItems = currentProp.items && currentProp.items.map(({ $$hashKey: _$$hashKey, ...rest }) => ({ ...rest }));
  // inserting array 'subItems' into 'array' in 'index' position
  array.splice(index, 1, ...subItems);
}

export const getPropName = (name) => {
  if (name.length <= 25) {
    return name;
  }
  return `${name.substring(0, 21)}...`;
};

export const getSummary = (items) => {
  let summary = '';
  if (!items || items.length === 0) {
    return {
      summary: '()',
      fullSummary: '()',
    };
  }
  if (items.length === 1) {
    summary = items[0].displayName;
  } else if (items.length === 2) {
    summary = `${items[0].displayName}, ${items[1].displayName}`;
  } else if (items.length > 2) {
    summary = `${items[0].displayName}...${items[items.length - 1].displayName}`;
  }

  return {
    summary: `(${removeAdditionalInfo(summary)})`,
    fullSummary: `(${summary})`,
  };
};

export const getElementId = (context, item) => {
  switch (context) {
    case 'tgitems':
      return item.targetId;
    case 'substances':
      return get(item, 'details.id', item.id);
    case 'citations':
      return item.id;
    case 'reactions':
      return item.id;
    default: {
      Logger.warn('invalid context: ', context);
      return undefined;
    }
  }
};

export const setStructureUID = (node) => {
  if (node.type === 'structure' && !node.structureUID) {
    // eslint-disable-next-line no-param-reassign
    node.structureUID = StructureContainers.generateUID();
  }
};

export const ungroup = (index, parent) => {
  const isImmutable = (fact) => every(fact.items, (item) => item.isImmutable);
  const array = isArray(parent) ? parent : parent.items;
  const currentItem = array[index];

  if (currentItem.isShell && !isImmutable(currentItem)) {
    removeShell(index, parent);
  }
  return parent;
};

export function Shell(dropObj, displayName, isImmutable) {
  let operator;
  let operatorQualifier;
  let items;

  if (isArray(dropObj)) {
    operator = get(dropObj[0], 'operator', 'AND');
    operatorQualifier = get(dropObj[0], 'operatorQualifier');
    items = dropObj;
  } else {
    operator = dropObj.operator || 'AND';
    operatorQualifier = dropObj.operatorQualifier;
    items = [dropObj];
  }

  const props = {
    id: 'wrapper',
    displayName,
    type: 'fact',
    isShell: true,
    isImmutable,
    items,
    operator,
    ...(operatorQualifier && { operatorQualifier }),
  };

  defaults(this, props);
}

export const convertToShell = (dropObj, dropListName) => {
  const childObj = { ...dropObj };

  childObj[dropListName] = []; // clean since it will be a child of a shell

  Object.keys(dropObj).forEach((key) => {
    // shell should have no child props
    if (SHELL_PROPS.indexOf(key) === -1) {
      // eslint-disable-next-line no-param-reassign
      delete dropObj[key];
    }
  });

  groupCount += 1;
  extend(dropObj, { id: 'wrapper', uuid: uuid(), isShell: true, groupName: dropObj.groupName || `Group ${groupCount}` });

  if (!childObj.isShell) {
    dropObj[dropListName].unshift(childObj); // add child to shell
  }
  return { dropObj };
};

export const isScrolledToBottom = (el) => el.scrollTop >= el.scrollHeight - el.offsetHeight;

export const getXCenterOfElement = (el) => {
  const { left, right } = el.getBoundingClientRect();
  return (left + right) / 2;
};
